var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDynamicFormIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "66px",
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "layers-grid-settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a/icons/64/additional-attributes",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#D2D2D9",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "layers-grid-settings"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4089957,30.5174669 L52.5862372,34.3927008 C52.9911046,35.7265871 54.3589033,36.5195461 55.7171987,36.2078247 L59.6441202,35.2974788 C61.1718542,34.9530221 62.7456784,35.6445586 63.5256187,37.0030048 C64.305559,38.361451 64.1095712,40.0697348 63.042257,41.2161191 L60.2953601,44.1810071 C59.3545692,45.2038455 59.3545692,46.7772807 60.2953601,47.8001192 L63.042257,50.7650072 C64.1095712,51.9113914 64.305559,53.6196753 63.5256187,54.9781214 C62.7456784,56.3365676 61.1718542,57.0281042 59.6441202,56.6836474 L55.7171987,55.7733015 C54.3517388,55.4544613 52.9743645,56.255024 52.5751049,57.5995612 L51.3978634,61.4747951 C50.9451388,62.9741693 49.5641259,64 47.998335,64 C46.4325441,64 45.0515313,62.9741693 44.5988067,61.4747951 L43.4299144,57.5995612 C43.0285632,56.2640406 41.6603613,55.4689245 40.301736,55.7816533 L36.3748145,56.6919992 C34.8470805,57.036456 33.2732563,56.3449194 32.493316,54.9864732 C31.7133757,53.6280271 31.9093635,51.9197432 32.9766777,50.773359 L35.7235746,47.808471 C36.6643655,46.7856325 36.6643655,45.2121973 35.7235746,44.1893588 L32.9766777,41.2244709 C31.9093635,40.0780866 31.7133757,38.3698028 32.493316,37.0113566 C33.2732563,35.6529104 34.8470805,34.9613739 36.3748145,35.3058306 L40.301736,36.2161765 C41.6595476,36.5291527 43.0274053,35.735454 43.4299144,34.4010526 L44.609939,30.5258187 C45.0608198,29.0258852 46.4405743,27.9983546 48.0063673,27.9964285 C49.5721603,27.9945079 50.9544336,29.0186456 51.4089957,30.5174669 Z",
    id: "Path",
    fill: "#EEF0F3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 48.0080758,
    cy: 45.9989149,
    rx: 3.99928145,
    ry: 4.00051085
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0476917,50.0829437 L5.56615372,50.0829437 C2.4920519,50.0829437 0,47.5901257 0,44.5150789 L0,5.56786478 C0,2.49281797 2.4920519,0 5.56615372,0 L44.5292297,0 C47.6033315,0 50.0953835,2.49281797 50.0953835,5.56786478 L50.0953835,25.0553915",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 16.7035943,
    x2: 50.0953835,
    y2: 16.7035943,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 33.3821333,
    x2: 27.8307686,
    y2: 33.3821333,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.3969223,
    y1: 0,
    x2: 33.3969223,
    y2: 27.8393239,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.6984612,
    y1: 0,
    x2: 16.6984612,
    y2: 50.0857277,
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicFormIcon);
export default __webpack_public_path__ + "static/media/dynamic-form-icon.ee738aca2857af113e8215d03c30b17a.svg";
export { ForwardRef as ReactComponent };